import { useEffect, useState } from 'react';
import { ApiError, parentalApi, type Bedtime } from '../api';
import { useApp } from '../context';

/**
 * Bedtijd voor kinderprofielen: in het ingestelde tijdvak toont de app alleen dit scherm.
 * Met de ouder-PIN is hij een uur open. Alleen actief voor kinderprofielen.
 */
export function BedtimeGate() {
  const { me } = useApp();
  const [locked, setLocked] = useState(false);
  const [bedtime, setBedtime] = useState<Bedtime | null>(null);
  const [pinSet, setPinSet] = useState(false);
  const [pin, setPin] = useState('');
  const [error, setError] = useState<string | null>(null);
  const restricted = !!me.profile?.restricted;

  useEffect(() => {
    if (!restricted) return;
    const check = () => parentalApi.status().then((s) => {
      setLocked(s.locked);
      setBedtime(s.bedtime);
      setPinSet(s.pinSet);
    }).catch(() => undefined);
    void check();
    const t = window.setInterval(check, 60_000);
    return () => window.clearInterval(t);
  }, [restricted]);

  // Wat er ook speelt: stoppen
  useEffect(() => {
    if (!locked) return;
    document.querySelectorAll('video').forEach((v) => v.pause());
  }, [locked]);

  if (!restricted || !locked) return null;

  const unlock = async (code: string) => {
    setError(null);
    try {
      await parentalApi.unlock(code);
      setLocked(false);
      setPin('');
    } catch (err) {
      setError(err instanceof ApiError && err.message !== err.code ? err.message : 'Onjuiste ouder-PIN.');
      setPin('');
    }
  };

  return (
    <div className="bedtime" role="dialog" aria-modal="true" aria-label="Het is bedtijd">
      <div className="bedtime-moon" aria-hidden="true">🌙</div>
      <h1>Het is bedtijd</h1>
      {bedtime && <p className="muted">tumedia gaat morgen om {bedtime.to} weer open. Slaap lekker!</p>}
      {pinSet && (
        <form className="bedtime-form" onSubmit={(e) => { e.preventDefault(); if (pin.length >= 4) void unlock(pin); }}>
          <label htmlFor="parent-pin" className="subtle">Ouder? Voer de ouder-PIN in voor een uur extra.</label>
          <input
            id="parent-pin"
            className="pin-input"
            inputMode="numeric"
            autoComplete="off"
            type="password"
            maxLength={8}
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
          />
          {error && <p className="error" role="alert">{error}</p>}
          <button type="submit" className="btn" disabled={pin.length < 4}>Ontgrendelen</button>
        </form>
      )}
    </div>
  );
}
